// extracted by mini-css-extract-plugin
export default {"action":"SapChecks_action__vYi4+","rerunButton":"SapChecks_rerunButton__fGz9F"};